export const getUserLevel = (role: WorkspaceRole) => {
  let level = 0;
  switch (role) {
    case "OWNER": {
      level = 1;
      break;
    }
    case "ADMIN": {
      level = 2;
      break;
    }
    // case "CONTRIBUTOR": {
    //   level = 3;
    //   break;
    // }
    case "CUSTOM": {
      level = 2.5;
      break;
    }
    case "WRITER": {
      level = 3;
      break;
    }
    case "SILENTREADER": {
      level = 4;
      break;
    }
    case "READER": {
      level = 5;
      break;
    } 
  }
  return level;
};

export const checkAccess = (
  minRole: WorkspaceRole,
  userRole: WorkspaceRole
) => {
  if (getUserLevel(userRole) > getUserLevel(minRole)) return false;
  else return true;
};

export const checkSampleWorkspaceAccess = (
  activeWorkspace: Workspace
) => {
  return activeWorkspace.featureFlags.includes("enable-sample-workspace");
};
